import { Container, Icon, Spacer, Text } from 'roadie-ui'
import Panel, { PanelTitle } from 'components/layout/Panel'
import { LocalizedRichText, LocalizedText, useLocalization, type TranslationKey } from 'localization'

const TIPS: { icon: React.ReactNode; titleKey: TranslationKey; bodyKey: TranslationKey }[] = [
  {
    icon: <Icon.LightbulbShine $width="2.4rem" $height="2.4rem" $color="neutral-black" />,
    titleKey: 'dweb_dashboard_commitment_rate_tips_offer_carefully_title',
    bodyKey: 'dweb_dashboard_commitment_rate_tips_offer_carefully_body',
  },
  {
    icon: <Icon.SpeedClock $width="2.4rem" $height="2.4rem" $color="neutral-black" />,
    titleKey: 'dweb_dashboard_commitment_rate_tips_act_fast_title',
    bodyKey: 'dweb_dashboard_commitment_rate_tips_act_fast_body',
  },
]

const CommitmentRateTips: React.FC = () => {
  const { t } = useLocalization()

  return (
    <>
      <PanelTitle>
        <LocalizedText translationKey="dweb_dashboard_commitment_rate_tips_road_success" />
      </PanelTitle>
      <Panel left noPadding>
        <Container.Base $padding="2.4rem" $textAlign="left" $color="neutral-black">
          <Text.Body2>
            <LocalizedRichText
              translationKey="dweb_dashboard_commitment_rate_tips_keep_rate_above_strong_text1_access_more_gigs"
              params={{ strongText1: <strong>95%</strong> }}
            />
          </Text.Body2>

          <Spacer $height="1.6rem" />

          <Text.Body2>
            <LocalizedText translationKey="dweb_dashboard_commitment_rate_tips_tips_great_commitment_rate" />
          </Text.Body2>

          <Spacer $height="1.6rem" />

          {TIPS.map((tip) => (
            <Container.Grid
              key={tip.titleKey}
              $gridTemplateColumns="2.4rem 1fr"
              $gridGap="1.2rem"
              $alignItems="start"
              $padding="0 0 1.6rem 0"
            >
              {tip.icon}
              <Text.Body2>
                <strong>{t(tip.titleKey)}</strong> {t(tip.bodyKey)}
              </Text.Body2>
            </Container.Grid>
          ))}
        </Container.Base>
      </Panel>
    </>
  )
}

export default CommitmentRateTips
